import { render, staticRenderFns } from "./channel-form.vue?vue&type=template&id=0b0c010a"
import script from "./channel-form.vue?vue&type=script&lang=js"
export * from "./channel-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports